import React from "react";
import { Typography, Button } from "@material-ui/core";
import FilterList from "../../small-components/FilterList";
import "./template-list.scss";
import FilterBox from "../../small-components/FilterBox";
import PaginationList from "../../small-components/pagination";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import { debounce } from "lodash";
import SettingsTable from "../SettingsTable";
import EstimateFor from "../EstimateFor";
import AlertDialog from "../../small-components/AlertDialog/AlertDialog";
// import NoContent from '../../small-components/nocontent';
import CreateTemplate from "../../reusable-components/createTemplate";
import fire from "../../../config/firebase";
import { getCopyName } from "../../../libs/getCopyName";
import Moment from "moment";
class TemplateList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      age: "",
      key: "",
      typeCast: "",
      ListItem: [],
      editList: [
        {
          type: "Create Estimate",
          icon: <TouchAppIcon htmlColor="#000000" fontSize="small" />,
          id: "create-estimates",
        },
        {
          type: "Edit",
          icon: <CreateIcon htmlColor="#000000" fontSize="small" />,
          id: "edit",
        },
        {
          type: "Delete",
          icon: <DeleteIcon htmlColor="#000000" fontSize="small" />,
          id: "delete",
        },
      ],
      anchorStyle: {
        fontSize: "20px",
        textDecoration: "underline",
        position: "absolute",
        top: "0",
        zIndex: "99999999",
        cursor: "pointer",
      },
      sort: "recent",
      itemKey: "",
      deleteId: "",
      favoriteValue: "",
      dialogOpen: false,
      optionAction: "",
      uniqueId: "",
      newTemplateArray: "",
      loader: true,
      arrayItem: [],
      currentUser: "",
      userEmail: "",
      userName: "",
      users: [],
      favoriteestimate: [],
      searchKey: "",
      dataLength: 0,
    };
    this.paginationCount = 6;
    this.refreshData = this.refreshData.bind(this);
  }
  handleSort = (e) => {
    this.setState({ sort: e });
  };
  handleFavorite = (id) => {
    for (let i = 0; i < this.state.users.length; i++) {
      if (this.state.users[i]["caption"] === this.state.userEmail) {
        const userID = this.state.users[i]["id"];
        let favoriteItems = [];
        if (this.state.users[i]["favoritetemplates"]) {
          favoriteItems = this.state.users[i]["favoritetemplates"];
        }
        let recentExist = 0;
        const recentExistIndex = 0;
        this.setState({ favoriteestimate: favoriteItems });
        if (this.state.users[i]["favoritetemplates"]) {
          favoriteItems = this.state.users[i]["favoritetemplates"];
          for (let k = 0; k < favoriteItems.length; k++) {
            if (id === favoriteItems[k]["id"]) {
              recentExist = 1;
            }
          }
        }
        if (recentExist === 1) {
          favoriteItems.splice(recentExistIndex, 1);
          const userRef = fire.database().ref("users").child(userID);
          userRef.update({
            favoritetemplates: favoriteItems,
          });
        }
        if (recentExist === 0) {
          favoriteItems.unshift({ id });
          const userRef = fire.database().ref("users").child(userID);
          userRef.update({
            favoritetemplates: favoriteItems,
          });
        }
      }
    }
    this.refreshData();
  };
  inputText = debounce((e) => {
    this.setState({
      key: e,
      page: 1,
    });
  }, 700);
  handlePageChange = (event, value) => {
    this.setState({
      page: value,
    });
  };
  handleChange = (event) => {
    this.setState({
      age: event.target.value,
      page: 1,
    });
  };

  handlePages = (key) => {
    const val = key.toLowerCase().split(" ").join("-");
    if (val === "time-based")
      this.setState({
        typeCast: true,
      });
    else
      this.setState({
        typeCast: true,
      });
  };
  optionChange = debounce((value, itemIndex) => {
    if (value === "Delete") {
      this.setState({
        dialogOpen: true,
        phaseKey: itemIndex,
        optionAction: value,
        drawerState: false,
      });
    } else if (value === "Duplicate") {
      let projectName = "",
        copy = "";
      for (let i = 0; i < this.state.arrayItem.length; i++) {
        if (this.state.arrayItem[i]["id"] === itemIndex) {
          copy = this.state.arrayItem[i];
          projectName = this.state.arrayItem[i]["projectName"];
          copy.id = null;
          copy.projectName = getCopyName(projectName, this.state.arrayItem, 'projectName');
          copy.date = Moment(new Date()).format("DD/MM/YYYY");
          copy.timestamp = Math.floor(Date.now() / 1000);
          copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");
          const estimateRef = fire.database().ref("templates");
          estimateRef.push(copy);
        }
      }
    } else if (value === "Edit") {
      for (const item of this.state.ListItem) {
        if (item["id"] === itemIndex) {
          this.setState({
            phaseKey: itemIndex,
            optionAction: value,
            drawerState: true,
            drawerType: "old",
            drawerDefaultName: item["title"],
            drawerDefaultColor: item["borderColor"],
            typeCast: true,
          });
        }
      }
      setTimeout(() => {
        this.setState({
          optionAction: "",
        });
      }, 1000);
      this.props.checkEditScreen("template");
    } else if (value === "Estimate") {
      let copy = "";
      for (let i = 0; i < this.state.arrayItem.length; i++) {
        if (this.state.arrayItem[i]["id"] === itemIndex) {
          copy = this.state.arrayItem[i];
          copy.id = null;
          copy.date = Moment(new Date()).format("DD/MM/YYYY");
          copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");
          copy.timestamp = Math.floor(Date.now() / 1000);
          const templatesRef = fire.database().ref("estimates");
          templatesRef.push(copy);
          // const estimateRef = fire.database().ref('templates').child(itemIndex);
          // estimateRef.remove();
        }
      }
    }
    this.refreshData();
  });
  drawerDelete = () => {
    this.setState({
      dialogOpen: true,
      optionAction: "delete",
    });
  };
  closeHandler = () => {
    this.setState({ dialogOpen: false });
  };
  deleteHandler = debounce((key) => {
    const estimateRef = fire.database().ref("templates").child(key);
    estimateRef.remove();
    this.setState({
      deleteId: key,
      dialogOpen: false,
      page: 1,
    });
    setTimeout(() => {
      this.setState({
        deleteId: "",
      });
    }, 300);
    this.refreshData();
  });
  templateId = (arr) => {
    this.setState({ newTemplateArray: arr });
    setTimeout(() => {
      this.setState({
        newTemplateArray: "",
      });
    }, 200);
  };
  createNewTemplate = (e) => {
    e.preventDefault();
    document.querySelector(".overlay").classList.add("activeOverlay");
  };
  searchHandler = debounce((value) => {
    this.setState({
      searchKey: value,
    });
  });
  refreshData() {
    const reftagList = fire.database().ref("tags");
    reftagList.once("value").then((snapshot) => {
      const tags = snapshot.val();
      reftagList.off("value");
      const allTags = [];
      for (const id in tags) {
        allTags.push({ id, ...tags[id] });
      }
      this.setState({ allTags });
    });
    const ref = fire.database().ref("templates");
    ref.once("value").then(
      (snapshot) => {
        const templates = snapshot.val();
        ref.off("value");
        const templatesList = [];
        for (const id in templates) {
          if (!templates[id].tags) {
            templates[id].tags = [];
          }
          templatesList.unshift({ id, ...templates[id] });
        }
        this.setState({
          ListItem: templatesList,
          arrayItem: templatesList,
          dataLength: templatesList.length,
          loader: false,
        });
      },
      (error) => {
        console.log("Error: " + error.code);
      }
    );
    if (this.props.update) {
      this.props.update();
    }

  }
  componentDidMount = () => {
    this.refreshData();

    //users
    const userListRef = fire.database().ref("users");
    userListRef.once("value").then((snapshot) => {
      const users = snapshot.val();
      userListRef.off("value");
      const userlist = [];
      for (const id in users) {
        userlist.push({ id, database: "users", ...users[id] });
      }
      this.setState({ users: userlist });
    });
    //Current User

    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          currentUser: user,
          userEmail: user.email,
          userName: user.displayName,
        });
      }
    });
  };
  handleCloseEditScreen = () => {
    this.setState({
      typeCast: false,
    });
  };
  render() {
    const { estimateType } = this.props;
    const th = this;
    let listToShow = this.state.arrayItem ? [...this.state.arrayItem] : [];
    let favoriteestimates = [];
    for (let i = 0; i < this.state.users.length; i++) {
      if (this.state.users[i]["caption"] === this.state.userEmail) {
        const favoriteestimate = this.state.users[i]["favoritetemplates"];
        favoriteestimates = favoriteestimate;
      }
    }
    // Filters
    if (
      th.state.sort !== "favourites" &&
      this.state.age === "" &&
      this.state.searchKey === ""
    ) {
      listToShow = this.state.arrayItem.sort(function (a, b) {
        if (th.state.sort === "ascending") {
          return a["projectName"].localeCompare(b["projectName"]);
        } else if (th.state.sort === "descending") {
          return b["projectName"].localeCompare(a["projectName"]);
        } else if (th.state.sort === "recent") {
          return b.timestamp - a.timestamp;
        } else {
          return a["id"].toString().localeCompare(b["id"].toString());
        }
      });
    } else if (
      th.state.sort !== "favourites" &&
      this.state.age !== "" &&
      this.state.searchKey === ""
    ) {
      listToShow =
        this.state.arrayItem.sort(function (a, b) {
          if (th.state.sort === "ascending") {
            return a["projectName"].localeCompare(b["projectName"]);
          } else if (th.state.sort === "descending") {
            return b["projectName"].localeCompare(a["projectName"]);
          } else if (th.state.sort === "recent") {
            return b.timestamp - a.timestamp;
          } else {
            return a["id"].toString().localeCompare(b["id"].toString());
          }
        }) &&
        this.state.arrayItem.filter(function (i) {
          return i.filterType.toLowerCase().match(th.state.age.toLowerCase());
        });
    } else if (
      th.state.sort !== "favourites" &&
      this.state.age === "" &&
      this.state.searchKey !== ""
    ) {
      listToShow =
        this.state.arrayItem.sort(function (a, b) {
          if (th.state.sort === "ascending") {
            return a["projectName"].localeCompare(b["projectName"]);
          } else if (th.state.sort === "descending") {
            return b["projectName"].localeCompare(a["projectName"]);
          } else if (th.state.sort === "recent") {
            return b.timestamp - a.timestamp;
          } else {
            return a["id"].toString().localeCompare(b["id"].toString());
          }
        }) &&
        this.state.arrayItem.filter(function (i) {
          return i.projectName
            .toLowerCase()
            .match(th.state.searchKey.toLowerCase());
        });
    } else if (
      th.state.sort !== "favourites" &&
      this.state.age !== "" &&
      this.state.searchKey !== ""
    ) {
      listToShow =
        this.state.arrayItem.sort(function (a, b) {
          if (th.state.sort === "ascending") {
            return a["projectName"].localeCompare(b["projectName"]);
          } else if (th.state.sort === "descending") {
            return b["projectName"].localeCompare(a["projectName"]);
          } else if (th.state.sort === "recent") {
            return b.timestamp - a.timestamp;
          } else {
            return a["id"].toString().localeCompare(b["id"].toString());
          }
        }) &&
        this.state.arrayItem.filter(function (i) {
          return (
            i.projectName
              .toLowerCase()
              .match(th.state.searchKey.toLowerCase()) &&
            i.filterType.toLowerCase().match(th.state.age.toLowerCase())
          );
        });
    } else if (th.state.sort === "favourites") {
      listToShow = [];
      for (let i = 0; i < favoriteestimates.length; i++) {
        for (let l = 0; l < this.state.arrayItem.length; l++) {
          if (favoriteestimates[i]["id"] === this.state.arrayItem[l]["id"]) {
            listToShow.push(this.state.arrayItem[l]);
          }
        }
      }
      if (this.state.age !== "" && this.state.searchKey === "") {
        listToShow = listToShow.filter(function (i) {
          return i.filterType.toLowerCase().match(th.state.age.toLowerCase());
        });
      } else if (this.state.age === "" && this.state.searchKey !== "") {
        listToShow = listToShow.filter(function (i) {
          return i.projectName
            .toLowerCase()
            .match(th.state.searchKey.toLowerCase());
        });
      } else if (this.state.age !== "" && this.state.searchKey !== "") {
        listToShow = listToShow.filter(function (i) {
          return (
            i.projectName
              .toLowerCase()
              .match(th.state.searchKey.toLowerCase()) &&
            i.filterType.toLowerCase().match(th.state.age.toLowerCase())
          );
        });
      }
    }
    listToShow = listToShow.filter(
      (d) => d.archive !== "true" && d.projectName
    );
    const count = Math.ceil(listToShow.length / this.paginationCount);
    const showEmpty = () => {
      const res = listToShow.length === 0 && this.state.loader === false;
      return res;
    };
    return (
      <React.Fragment>
        {this.state.typeCast && (
          <React.Fragment>
            <EstimateFor
              closeEditScreen={this.handleCloseEditScreen}
              title={
                this.state.typeCast === "true" ? "Time Based" : "Task Based"
              }
              type={this.state.typeCast}
            />
            <SettingsTable
              type={this.state.typeCast}
              update={this.props.update}
            />
          </React.Fragment>
        )}

        {
          <div className="time-based-table">
            <div className="section-intro">
              <Typography variant="h5" gutterBottom>
                Manage Templates
              </Typography>
              <Button
                className={this.props.classes.newestimate}
                onClick={this.createNewTemplate}
              >
                Create Template
              </Button>
            </div>
            <div className="filters">
              <FilterBox
                handleChange={this.handleChange}
                age={this.state.age}
                handleSort={this.handleSort}
                classes={this.props.classes}
                placeholder="Search Template"
                change={this.searchHandler}
                defaultSearchValue=""
              />
            </div>
            {showEmpty() ? (
              <CreateTemplate
                classes={this.props.classes}
                templateId={this.templateId}
                createTemplate={this.createNewTemplate}
                estimateType={estimateType}
                key={listToShow.length + "create"}
                listToShow={listToShow}
                refreshData={this.refreshData}
              />
            ) : null}
            <FilterList
              items={listToShow.length ? listToShow : []}
              page={this.state.page}
              classes={this.props.classes}
              list={this.state.editList}
              date={true}
              typecast={this.handlePages}
              // overlay={this.createNew}
              handleFavorite={this.handleFavorite}
              optionChange={this.optionChange}
              favoriteestimate={favoriteestimates}
              dataType="templates"
              allTags={this.state.allTags}
              refreshData={this.refreshData}
            />

            <div className={this.props.classes.pagination}>
              {count > 1 && (
                <PaginationList
                  count={count}
                  page={this.state.page}
                  handlePageChange={this.handlePageChange}
                />
              )}
            </div>
          </div>
        }

        <AlertDialog
          open={this.state.dialogOpen}
          onClose={this.closeHandler}
          phaseKey={this.state.phaseKey}
          keyValue={this.deleteHandler}
          name={""}
        />
      </React.Fragment>
    );
  }
}
export default TemplateList;
